export const glowUpProductQueryKeys = {
  all: ['glow-up-products'] as const,
  byCategory: (categoryId: number) =>
    ['glow-up-products', 'category', categoryId] as const,
};
